/*
 * Copyright © 2026. Legalbird eine Marke der Legalbird GmbH
 */

import React from "react";
import LayoutPublicRoutes from "@/src/containers/Layouts/LayoutPublicRoutes";
import LandingPageTeaser from "@/src/components/Teaser/LandingPageTeaser";
import PartnerLogoSection from "@/src/components/Sections/Generic/PartnerLogoSection/PartnerLogoSection";
import Container from "@/src/components/Container/Container";
import AttorneySection from "@/src/components/Sections/Generic/AttorneySection/AttorneySection";
import LinkedCardBox from "@/src/components/LinkedCardBox/LinkedCardBox";
import { contractTeaserCards } from "@/src/services/landingPageService";
import { useCustomer } from "@/src/provider/Customer/CustomerProvider";
import PartnerCheckin from "@/src/components/Checkin/PartnerCheckin/PartnerCheckin";
import LpCivilLawAdvocardMeta from "./LpCivilLawAdvocardMeta";
import HowItWorksSectionCivilLaw from "@/src/components/Sections/CivilLaw/HowItWorksSection/HowItWorksSectionCivilLaw";
import { PARTNER_IRIS } from "@/src/constants/partnerIris";
import Grid from "@mui/material/Grid";
import ValidatorMultiSelectFieldWithCheckboxes from "@/src/components/FormFields/ValidatorMultiSelectFieldWithCheckboxes";
import { requiredValidator } from "@/src/services/validationRules";
import { translate } from "@/src/services/translations/translations";
import applicationFormStyle from "@/src/components/Form/applicationFormStyle";

const LpCivilLawAdvocard = () => {
  const { isLoggedIn } = useCustomer();

  const additionalFieldsConfig = [
    {
      key: "case.objectivesClient",
      initialValue: [],
      fieldToRender: (
        <Grid
          sx={applicationFormStyle.gridSpaceMd}
          size={{
            xs: 12,
            md: 6,
          }}
        >
          <ValidatorMultiSelectFieldWithCheckboxes
            label="Ihr Anliegen"
            name={`case.objectivesClient`}
            validators={[requiredValidator("Bitte geben Sie die Art Ihres Anliegens an.")]}
            options={[
              { value: "payment", label: translate("generalCivilLaw.objectivesClient.options.payment.label", {}) },
              {
                value: "injunction",
                label: translate("generalCivilLaw.objectivesClient.options.injunction.label", {}),
              },
              { value: "removal", label: translate("generalCivilLaw.objectivesClient.options.removal.label", {}) },
              { value: "handover", label: translate("generalCivilLaw.objectivesClient.options.handover.label", {}) },
              { value: "other", label: translate("generalCivilLaw.objectivesClient.options.other.label", {}) },
            ]}
          />
        </Grid>
      ),
    },
  ];

  return (
    <LayoutPublicRoutes minimal={!isLoggedIn} clickableLogo={isLoggedIn}>
      <LpCivilLawAdvocardMeta />
      <LandingPageTeaser
        teaserButtonText={"Jetzt starten"}
        headline={"Fragen oder Probleme bei rechtlichen Streitigkeiten im Alltag?"}
        subheadline={"Wir sorgen dafür, dass Sie zu Ihrem Recht gelangen!"}
        teaserButtonLink={isLoggedIn ? "/servicewelt" : "#top-checkin"}
      >
        <LinkedCardBox linkedCards={contractTeaserCards} />
      </LandingPageTeaser>
      <PartnerLogoSection partnerIri={PARTNER_IRIS.ADVOCARD} containerStyle={"settlementContainer"} />
      {!isLoggedIn && (
        <Container>
          <PartnerCheckin idPrefix={"top"} partner={PARTNER_IRIS.ADVOCARD} additionalFormFields={additionalFieldsConfig} productName={"generalCivilLaw"} />
        </Container>
      )}
      <HowItWorksSectionCivilLaw />
      <AttorneySection
        subheading={"Sie möchten sich professionell und schnell unterstützen lassen? Wir helfen Ihnen - jederzeit und ortsunabhängig!"}
        heading={"Deutschlandweit tätige Partneranwälte"}
      />
      {!isLoggedIn && (
        <Container>
          <PartnerCheckin idPrefix={"top"} partner={PARTNER_IRIS.ADVOCARD} additionalFormFields={additionalFieldsConfig} productName={"generalCivilLaw"} />
        </Container>
      )}
    </LayoutPublicRoutes>
  );
};

export default LpCivilLawAdvocard;
